import * as actionTypes from './actionTypes';

import userService from 'services/userService'
import loginService from 'services/loginService'
import objectUtils from 'utils/object'
import { ERROR_CODES, knownError, userError } from 'utils/userError'

const resetLinkInvalid = () =>
  knownError(ERROR_CODES.AUTH_RESET_LINK_INVALID, {
    title: "This password link can't be used",
    message: 'It has expired or has already been used.',
    guidance: 'Ask for a new link with Forgot password on the sign-in page.',
  })

export const sendRequestChangePassword = passwordData => {
  return dispatch => {
    userService.changePassword(passwordData)
    .then((userDetails) => {
      if(userDetails.idUser){
        dispatch(tryAutomaticallyLogin())
      }else{
        dispatch(requestFailed(resetLinkInvalid()))
      }
    })
    .catch((err) => {
      dispatch(requestFailed(userError(err, {
        area: 'AUTH',
        code: ERROR_CODES.AUTH_PASSWORD_CHANGE_FAILED,
        task: 'change your password',
      })))
    });
  }
}

export const resetPassword = payload => {
  return dispatch =>{
    userService.resetPassword(payload)
    .then(data => {
      if(data.valid){
        dispatch(tryAutomaticallyLogin())
      }else{
        dispatch(requestFailed(resetLinkInvalid()))
      }
    })
    .catch(err => {
      dispatch(requestFailed(userError(err, { area: 'AUTH', task: 'reset your password' })))
    })
  }
}

export function tryAutomaticallyLogin() {
  return async dispatch => {
    dispatch(loggingIn())
    try {
      const response = await loginService.login()
      if (!!objectUtils.get(response, 'idUser', undefined)) {
        dispatch(requestSuccessLogin(response))
      } else {
        dispatch(loggingOut())
      }
    } catch (error) {
      dispatch(loggingOut())
    }
  }
}

const requestSuccessLogin = userDetails => {
  return {
    type: actionTypes.REQUEST_SUCCESS_LOGIN,
    userDetails: userDetails,
  }
}

const loggingIn = () => {
  return {
    type: actionTypes.USER_LOGGING_IN,
  }
}

function loggingOut() {
  return {
    type: actionTypes.USER_LOGGING_OUT,
  }
}


export const onCloseRequestEmailResetPasswordModal = () =>{
  return {
    type: actionTypes.CLOSE_SENT_EMAIL_RESET_PASSWORD_MODAL
  }
}

export const closeResetPasswordModalError = () =>{
  return {
    type : actionTypes.CLOSE_RESET_PASSWORD_MODAL_ERROR
  }
}

// error: a userError, shown by ModalError.
const requestFailed = error => {
  return {
    type: actionTypes.REQUEST_FAILED,
    errorMessage: error
  }
}

export const closeModalFailed = () => {
  return {
    type: actionTypes.CLOSE_MODAL_ERROR
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/Password.js